import { Injectable, NgZone, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, RoutesRecognized, NavigationError, Event as NavigationEvent } from '@angular/router';
import { LoggerService } from './logger.service';
import { RoutingHistoryService } from '../../routing/services/routing-history.service';
import { Title } from '@angular/platform-browser';
import { LoggerHelperService } from './logger-helper.service';

@Injectable()
export class LoggerListenerService {
    private isBrowser: boolean;
    private handleClick(event: any): void { };


    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private router: Router,
        private zone: NgZone,
        private logger: LoggerService,
        private routingHistoryService: RoutingHistoryService,
        private title: Title,
        private loggerHelperService : LoggerHelperService
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
        this.setRoutingListeningLogging();
        this.setErrorListeningLogging();
        this.setUserClickListeningLogging();
        // this.setDomListeningLogging();
    }

    private setRoutingListeningLogging(): void {
        this.router.events.forEach((event: NavigationEvent) => {
            switch(event.constructor) {
                case NavigationStart:
                    if (this.routingHistoryService.isFirstPage) {
                        this.logger.log('User enter the application URL [' + (event as NavigationStart).url + ']');
                    }
                    break;
                case NavigationEnd:
                    this.logger.log('User entered page [' + this.title.getTitle() + ']');
                    break;
                case NavigationCancel:
                    this.logger.warning('User navigation to URL [' + (event as NavigationCancel).url + '] was canceled');
                    break;
                // case NavigationError:
                //     this.logger.log("An error occurred while navigating user to url [" + (event as NavigationError).url + "]");
                //     break;
                // case RoutesRecognized:
                //     this.logger.log("User navigation route [" + (event as RoutesRecognized).url + "] was recognized");
                //     break;

            }
        });
    }

    private setErrorListeningLogging(): void {
        this.zone.onError.subscribe((event: any) => {
            let errorMessage = `ANGULAR. Error [${event}]`;
            if (event.message) {
                errorMessage += ` Message [${event.message}]`;
            }
            if (event.name) {
                errorMessage += ` Name [${event.name}]`;
            }
            // if (!isNullOrUndefined(event.stack)) {
            //    errorMessage += ` Stack [${event.stack}]`;
            // }
            this.logger.warning(errorMessage);
        });
    }


    private setUserClickListeningLogging(){
        if (this.isBrowser) {
            // "handleClick" content is handled by JS outside of angular scope
            // at the moment of execution "this" is "document"
            // this is why "that" is needed - to save the context of the service
            const that = this;
            this.handleClick = function(event: any) {
                if (event && event.path && event.path.length > 0) {
                    const elements =
                        event.path.filter(p => p instanceof HTMLButtonElement || p instanceof HTMLAnchorElement);
                    if (elements.length > 0) {
                        const element = elements[0] as HTMLBaseElement;
                        that.loggerHelperService.setCorrelationId();
                        that.logger.log('User clicked [' + element.nodeName + '] with text [' + element.textContent + ']');
                    }
                }
            };

            document.addEventListener('click', this.handleClick);

            window.onbeforeunload = () => {
                document.removeEventListener('click', this.handleClick, false);
            }
        }

    }

    // private setDomListeningLogging(): void {
    //     // todo: zone dome events: click
    // }
}
